export * from './DeleteWorkspaceMainConnectedProps'
export * from './DeleteWorkspaceMainMapDispatchReturnType'
export * from './DeleteWorkspaceMainMapStateReturnType'
export * from './DeleteWorkspaceMainProps'
